import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './component/header';
import { Footer } from './component/footer';
import ReweavingPage from './reweaving/page';
import HomePage from './home/page';
import AboutPage from './about/page';

const App: React.FC = () => {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/reweaving" element={<ReweavingPage />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
